import React from 'react'
import { cn } from '../utils/utils'

interface ButtonProps {
    children: React.ReactNode
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
    type?: 'button' | 'submit' | 'reset'
    variant?: 'primary' | 'secondary' | 'ghost'
    className?: string
    disabled?: boolean
    loading?: boolean
}

// TODO - add some loading styles
export function Button({
    children,
    onClick,
    className,
    type = 'submit',
    variant = 'primary',
    disabled = false,
    loading = false,
}: ButtonProps) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={cn(
                'w-fit h-11 rounded-[42px] py-3 px-[18px] text-base transition-colors duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed',
                variant === 'primary' && 'bg-blue40 hover:bg-blue50 text-white',
                variant === 'secondary' && 'bg-grey30 hover:bg-grey40 text-grey100',
                variant === 'ghost' && 'bg-transparent hover:opacity-85 text-grey100 px-[6px] ml-[-6px]',
                className
            )}
        >
            {children}
        </button>
    )
}
